import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateRememberSessions } from "./api";
import type { MeResponse } from "../auth/api";

// Переключение настройки «удерживать сессию» (remember-me). Влияет
// только на НОВЫЕ сессии. Инвалидируем `me` — тумблер перерисуется по
// свежему значению из БД.
export function useUpdateRememberSessions(): ReturnType<
  typeof useMutation<MeResponse, Error, boolean>
> {
  const queryClient = useQueryClient();
  return useMutation<MeResponse, Error, boolean>({
    mutationFn: (rememberSessions) => updateRememberSessions(rememberSessions),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["me"] });
    },
  });
}
